import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs';



import { DashboardService } from './dashboard.service';
import { LoaderService } from '../../common/services/loader.service';

@Injectable()
export class DashboardResolver  {
    constructor( public dashboardService: DashboardService, public loaderService: LoaderService ) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        this.loaderService.toggleLoader(true);
        return this.dashboardService.getDashboard(route.paramMap.get('dashboardid'));
    }
}